import React from "react";
import Team from "./Team";
import "./App.css";

function App() {
  return (
    <div>
      <Team />
    </div>
  );
}

export default App;
